module.exports = __webpack_public_path__ + "222141f2f65c509df5e09ce80cda6965.png";